<!--登录页面-->
<template>
    <div style=" background: #fff ; padding:20px; ">
        <el-table
                ref="multipleTable"
                :data="listData.list"applylist
                v-loading.body="loading"
                style="width: 100%;"
                :height="tableHeight"
                row-key="id"
                @sort-change="sortChange">
            <el-table-column type="selection" min-width="252px"></el-table-column>
            <el-table-column label="订单信息" fixed="left" prop="title" width="300">
                <template scope="scope">
                    <div v-for="(goods,i) in scope.row.items">
                        {{goods.title}}
                    <p>
                      规格: {{goods.sku.sku_formart}}*{{goods.count}}
                    </p> 
                    
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="金额"  prop="cate_list">
                <template scope="scope">
                    {{scope.row.pay_price}}
                </template>
            </el-table-column>
            <el-table-column label="状态"  prop="status">
                <template scope="scope">
                    <!-- <el-tag v-if="scope.row.status==1">提交申请</el-tag>
                    <el-tag v-else-if="scope.row.status==2">理论考试中</el-tag>
                    <el-tag v-else-if="scope.row.status==3">理论考试结束</el-tag>
                    <el-tag v-else-if="scope.row.status==4">实践考试中</el-tag> -->
                    <el-tag >{{scope.row.status_buttons.name}}</el-tag>
                    <!-- <el-tag type="success" v-else-if="scope.row.status==6">成功</el-tag>
                    <el-tag type="danger" v-else-if="scope.row.status==7">失败</el-tag> -->
                </template>
            </el-table-column>
            <el-table-column label="操作"  prop="leixing">
                <template scope="scope">
                     
                    <div  v-rblink="{name:'OrderDetail',query:{id:scope.row.id}}">
                        <el-button type="primary" plain>查看详情</el-button>
                    </div>
                </template>
            </el-table-column>

        </el-table>
        <div class="rb-table-pager">
            <el-pagination
                    background
                    :page-size="params.size"
                    @size-change="sizeChange"
                    @current-change="currentChange"
                    :current-page="parseInt(listData.currentpage)"
                    layout="total,sizes,prev, pager, next, jumper"
                    :total="parseInt(listData.total)">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'MineIndex',
        data(){
            return {
                navArr:[
                    {name:"首页"},
                    {name:"组织结构"},
                    {name:"新闻资讯"},
                    {name:"通知公告"},
                    {name:"免费课程"},
                    {name:"星星展示"},
                    {name:"资质查询"}
                ],
                activeIndex:"登录",
                inputusername:"",   //用户名
                inputpassword:"",    //密码
                inputmobilphone:"",     //手机号码
                inputIdecode:"",        //验证码
                inputpasswordagain:"",   //再次输入密码
                getidecodeData:"获取验证码",
                inputdepartment:"",
                meta: {
                    'title': '',
                    'tabs': []
                },
                keepAlive: true,
                activeName: '',
                keepAliveInclude:  this.$route.meta.keepAlive ? this.$route.name : '',
                keepAliveArray:  this.$route.meta.keepAlive ? [this.$route.name] : [],

                isCollapsed: false,
                user:{
                    userRole:{

                    }
                },

                tableHeight: 100,
                params: {
                    'status': 0,
                    'keywords': '',
                    'p': 1,
                    'size': 30,
                },
                listData: {},
                loading: false

            }
        },
        watch:{
        },
        created(){
            this.fetchData();
            this.tableHeight = window.innerHeight - 220;
        },
        methods:{
            fetchData(){
                let that = this;
                that.$api.get('/api/order/orderList', that.params, r => {
                    that.listData = r.data;
                });

            },
            
            sortChange(e){
                 
            },
            sizeChange(e){
                this.params.size = e;
                this.fetchData();
            },
            currentChange(e){
                this.params.p = e;
                this.fetchData();
            },
            
            
            deleteOne(id){
                console.log(id);
                let that = this;
                this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    that.$api.get('/adminapi/goods/goodsDelete',{
                        'id':id
                    },res => {
                        that.$message.success('删除成功');
                        that.$api.dataList.load('goodsList');
                    });
                }).catch(() => {
                    //取消
                });
            },
             
        }
    }
</script>
<style lang="scss" scoped>

    // @font-face {
    //     /* font-properties */
    //     font-family: EuclidFlex-Bold;
    //     src:url('~@/assets/font/EuclidFlex-Bold.ttf');
    // }
    .login{
        height: 100vh;
        display: flex;
        flex-direction: column;
        position: relative;
        z-index: 1;
        .loginhead{
            height: 100px;
            width: 100vw;
            background: #1981FF;
            // display: flex;
            // justify-content: space-around;
            // align-items: center;
            overflow: hidden;
            .headleft{
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: space-between;
                width: 1240px;
                margin: 0 auto;
                .logoAndname{
                    display: flex;
                    align-items: center;
                    width: 210px;
                    height: 40px;
                    background-size: cover;
                    -webkit-background-size: cover;
                }
                .headnav{
                    // margin-left: 80px;
                    height: 100px;
                    line-height: 100px;
                    a{
                        font-size: 18px;
                        font-family: "Euclid Flex Bold",Arial,"PingFang SC",Verdana,"\5FAE\8F6F\96C5\9ED1";
                        font-weight: 400;
                        color: #FFFFFF;
                        margin-right: 24px;
                        &:hover{
                            font-weight:bold;
                        };
                    }
                }
                .headlefticon{
                    display: flex;
                    flex-direction: row;
                    width: 64px;
                    height:36px;
                    // margin-left: 80px;
                    .headicon{
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        margin-left: 10px;
                        .loginbtn{
                            background: #4E81DF;
                            text-align: center;
                            height: 36px;
                            width: 64px;
                            line-height: 32px;
                            box-shadow: 0px 2px 8px 0px rgba(0,0,0,0.3);
                            border-radius: 19px;
                            border: 2px solid #FFFFFF;
                            font-size: 16px;
                            
                            font-weight: 400;
                            color: #FFFFFF;
                            box-sizing: border-box;
                            &:hover{
                                cursor: pointer;
                                opacity: 0.8;
                                font-weight: bold;
                            };
                        }
                        .registerbtn{
                            background: #D22C46;
                        }
                    }
                }
            }
        }
        .logincontainer{
            flex: 1;
            position: relative;
            background: #F8F8F8;
            .logincontainerEntureWidth{
                max-width: 1240px;
                height: 100%;
                margin: 0 auto;
                position: relative;
                .bgitem{
                    width: 543px;
                    height: 569px;
                    background: url("~@/assets/images/login/pic-bg.png") center center no-repeat;
                    position: absolute;
                    top: 66px;
                    right: 697px;
                    background-size: cover;
                    -webkit-background-size: cover;
                }
                .logincontainerItem{
                    position: absolute;
                    right: 0;
                    top: 87px;
                    width: 452px;
                    background: #FFFFFF;
                    box-shadow: 0px 0px 34px 0px rgba(0,0,0,0.05);
                    border-radius: 9px;
                    padding:0 13px 0 17px;
                    box-sizing: border-box;
                    .elmenu{
                        margin-bottom: 53px;
                    }
                    /*公用部分leftLogin/rightRegister*/
                    .containerInput{
                        margin-top: 24px;
                        margin-left: 26px;
                        .inputTitle{
                            width: 65px;
                            height: 14px;
                            line-height: 14px;
                            display: inline-block;
                            /*margin-right: 18px;*/
                            line-height: 10px;
                            font-size: 16px;
                            
                            font-weight: 400;
                            color: #000000;
                            margin-right: 5px;
                        }
                    }
                    .tipsCommon{
                        margin-left: 98px;
                        margin-top: 32px;
                        
                        cursor: pointer;
                    }
                    .loginFont{
                        width: 95px;
                        height: 40px;
                        background: #0486FE;
                        border-radius: 4px;
                        text-align: center;
                        line-height: 40px;
                        font-size: 14px;
                        font-weight: 400;
                        color: #FFFFFF;
                        &:hover{
                            font-weight:bold;
                            opacity: 0.8;
                        };
                    }
                    .forget{
                        margin-top: 20px;
                        display: flex;
                        flex-direction: row;
                        justify-content: space-between;
                        font-size: 14px;
                        font-weight: 400;
                        color: #999999;
                        margin-bottom: 32px;
                        .forgetpassword:hover{
                            font-weight:bold;
                        }
                        .forgetusername:hover{
                            font-weight:bold;
                        }
                    }
                    .leftLogin{
                        .containerInput{
                            .inputTitle{
                                width: 65px;
                            }
                        }
                    }
                    .rightRegister{
                        .containerInput{
                            .inputTitle{
                                width: 65px;
                            }
                            .getidecode{
                                width: 81px;
                                height: 34px;
                                text-align:center;
                                background: #E6F1FC;
                                border-radius: 3px;
                                border: 1px solid #A3D0FD;
                                font-size: 12px;
                                
                                font-weight: 400;
                                color: #1989FA;
                                line-height: 34px;
                                display: inline-block;
                                margin-left: 8px;
                                &:hover{
                                    font-weight:bold;
                                    opacity: 0.8;
                                    cursor: pointer;
                                };
                            }
                        }
                        .loginFont{
                            margin-bottom: 32px;
                        }
                    }

                }
            }

        }
    }

    .has-vertical-scrollerbar{ overflow:hidden; overflow-y:scroll;  }
    .has-vertical-scrollerbar::-webkit-scrollbar-track-piece,
    .has-vertical-scrollerbar::-webkit-scrollbar{ width: 0; }


    .inputidecode{
        .el-input__inner{
            padding-right:10px;
        }
    }

    .contain_warp{
        width: 1240px;
        margin:  0 auto;

    }
</style>



// WEBPACK FOOTER //
// orderList.vue?3452b025